import helpers from "../modules/helpers";

const single = {
  init: function () {
    single.read_more();
    single.share();
  },

  read_more: function () {
    // Init.
    let content = $(".blog-single__content");
    let blocks = content.find(".width-900");
    blocks.first().addClass("visible");

    // Show if more than one block
    if (blocks.length > 1) {
      $(".read-more").removeClass("read-more--hidden");
    }

    // Read more.
    $(".read-more").on("click", function (e) {
      e.preventDefault();
      let btn = $(this);

      let block = blocks.not(".visible").first();
      block.addClass("visible").slideDown();

      if (!block.next(".width-900").length) {
        btn.fadeOut();
      }
    });
  },

  share: function () {
    if ($(".share__item").length) {
      $("body").on("click", ".share__item", function (e) {
        e.preventDefault();

        helpers.share($(this));
      });
    }
  },
};

export default single;
